import React, { useCallback, useEffect, useState, Fragment } from "react";
import {
  Box,
  List,
  ListItem,
  Grid,
  Typography,
  TextField,
  Button,
  useMediaQuery,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import clsx from "clsx";
import _ from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronCircleLeft, faUser, faFile } from "@fortawesome/free-solid-svg-icons";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { Pagination } from "@material-ui/lab";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import FolderIcon from "@material-ui/icons/Folder";
import { isMobile } from "react-device-detect";
import moment from "moment";

//helpers
import { usePagination } from "@helpers";

//components
import { EmptyStateHolder } from "@components/organisms";
import { PDFViewer, ModuleList, PDFViewerAndToolBar } from "@components/molecules";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "space-between",
  },
  menu: {
    height: "auto",
  },
  list: {
    display: "inline-flex",
    overflow: "auto",
    flexWrap: "nowrap",
    width: "100%",
    [theme.breakpoints.up("md")]: {
      display: "flex",
      flexDirection: "column",
      marginRight: theme.spacing(-3),
      marginLeft: theme.spacing(-3),
    },
  },
  listItem: {
    marginRight: theme.spacing(2),
    flex: 0,
    [theme.breakpoints.up("md")]: {
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
      borderLeft: "2px solid transparent",
    },
  },
  listItemActive: {
    [theme.breakpoints.up("md")]: {
      borderLeft: `2px solid ${theme.palette.primary.dark}`,
    },
    "& .menu__item": {
      color: theme.palette.text.primary,
    },
  },
  pagePaddingTop: {
    marginTop: "100px",
    [theme.breakpoints.up("md")]: {
      marginTop: "100px",
    },
  },
  paperHolder: {
    padding: theme.spacing.unit,
    color: theme.palette.text.primary,
    whiteSpace: "wrap",
    marginBottom: theme.spacing.unit,
    display: "flex",
    flexDirection: "column",
    wordBreak: "break-all",
    // "& > div:first-child": {
    //   display: "flex",
    // },
  },
  paperTitle: {
    fontWeight: "bold",
    whiteSpace: "wrap",
    color: theme.palette.text.primary,
    marginBottom: theme.spacing.unit,
    flexGrow: 2,
    wordBreak: "break-word",
  },
  paperText: {
    whiteSpace: "wrap",
    marginBottom: theme.spacing.unit,
    paddingLeft: 30,
  },
  smallContainer: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  iconColor: {
    color: theme.palette.primary.main,
  },
  hidden: {
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  parentIcon: {
    padding: "0 12px 0 12px",
  },
  childIcon: {
    fontSize: "1rem",
    textAlign: "center",
    transition: "background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    margin: "0 12px 0 30px",
  },
  selfServiceWrapper: {
    display: "flex",
    flexDirection: "column",
    flexWrap: "wrap",
    wordBreak: "break-all",
    justifyContent: "center",
    "& > h5, & > a": {
      marginBottom: "1rem",
    },
    "& > h5": {
      color: theme.palette.background.header,
    },
  },
  contactsCategories: {
    maxHeight: "20rem",
    overflowY: "auto",
  },
}));

const DataListAndRowView = (props) => {
  const classes = useStyles();
  const theme = useTheme();

  const {
    isLoading,
    emptyStateText,
    fetchedData,
    mainDisplayColumns,
    altDisplayColumn,
    isPDFView,
    isForm,
    onRowSelected,
    module = "",
    pdfType,
    hasFilter,
    hasModal,
    setOpenModal,
    safetyFormSelected,
    setSafetyFormSelected,
    setOpenRespAlert,
    hasRespMedClearance,
  } = props;

  //on page load
  React.useEffect(() => {
    setOriginalData(fetchedData);
    setFilteredData(fetchedData);
  }, [fetchedData]);

  //variables
  const [selectedRow, setSelectedRow] = useState(null);
  const [originalData, setOriginalData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [categories, setCategories] = useState([]);
  const [notCategorized, setNotCategorized] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [holdCategories, setHoldCategories] = useState([]);
  const [holdNoCategory, setHoldNoCategory] = useState([]);
  const [lastSelectedIndex, setLastSelectedIndex] = useState(null);
  const [isViewingFile, setIsViewingFile] = useState(false);
  const [isFiltering, setIsFiltering] = useState(false);

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  //Paging/Filter Component
  // const PER_PAGE_DEFAULT = 20;
  // let [currentPage, setCurrentPage] = React.useState(1);
  // let [pageCount, setPageCount] = React.useState(0);

  // React.useEffect(() => {
  //   PreparePagedData();
  // }, [filteredData]);

  // const PreparePagedData = () => {
  //   const count = Math.ceil(filteredData.length / PER_PAGE_DEFAULT);
  //   setPageCount(count);
  // };

  // let currentPagedData = usePagination(filteredData, PER_PAGE_DEFAULT);

  // const handleChange = (e, p) => {
  //   setCurrentPage(p);
  //   currentPagedData.jump(p);
  // };
  const manipulateData = useCallback(() => {
    if (filteredData) {
      let temp = [],
        categories = [],
        noCategory = [];

      for (let i = 0; i < filteredData.length; i++) {
        if (
          !temp.includes(filteredData[i].categoryTitle) &&
          filteredData[i].categoryTitle
        ) {
          if (filteredData[i].categoryTitle !== null) {
            temp.push(filteredData[i].categoryTitle);
            categories.push({
              category: filteredData[i].categoryTitle,
              isViewing: false,
            });
          }
        }
        if (!filteredData[i].categoryTitle) {
          noCategory.push(filteredData[i]);
        }
      }
      if (categories.length > 0 && noCategory.length > 0) {
        categories.push({ category: "No Category", isViewing: false });
      }
      setCategories(categories);
      setHoldCategories(categories);
      setNotCategorized(noCategory);
      setHoldNoCategory(noCategory);
    }
  }, [filteredData]);

  useEffect(() => {
    manipulateData();
  }, [filteredData]);

  //helper method
  const titleCase = (s) => {
    return s
      .replace(/([^A-Z])([A-Z])/g, "$1 $2") // split cameCase
      .replace(/[_\-]+/g, " ") // split snake_case and lisp-case
      .toLowerCase()
      .replace(/(^\w|\b\w)/g, function (m) {
        return m.toUpperCase();
      }) // title case words
      .replace(/\s+/g, " ") // collapse repeated whitespace
      .replace(/^\s+|\s+$/, ""); // remove leading/trailing whitespace
  };

  const findByMatchingProperties = (set, properties) => {
    return set.filter(function (entry) {
      return Object.keys(properties).every(function (key) {
        return entry[key] === properties[key];
      });
    });
  };

  const findByValue = (set, properties, value) => {
    return set.filter(function (entry) {
      return Object.keys(properties).every(function (key) {
        return (
          entry[key] !== null &&
          entry[key].toString().toLowerCase().trim() ===
            value.toLowerCase().trim()
        );
      });
    });
  };

  const onFilterValueChange = (value) => {
    if (value.length > 0) {
      let searchCategories = [];
      if (categories) {
        holdCategories.forEach((folder) => {
          if (folder.category) {
            const categoryCase = folder.category.toLowerCase();
            const valueCase = value.toLowerCase();
            if (categoryCase.includes(valueCase)) {
              searchCategories.push(folder);
            }
          }
        });
      }

      let searchNoCategory = [];
      React.Children.toArray(
        mainDisplayColumns.forEach((column) => {
          filteredData.forEach((file) => {
            let titleCase = "",
              valueCase = value.toLowerCase();
            if (file[column]) {
              titleCase = file[column];
            } else if (
              file[altDisplayColumn] &&
              !file[altDisplayColumn].includes("http")
            ) {
              titleCase = file[altDisplayColumn];
            }
            titleCase = titleCase.toLowerCase();
            if (titleCase.includes(valueCase)) {
              searchNoCategory.push(file);
            }
          });
        })
      );

      setIsFiltering(true);
      setCategories(searchCategories);
      setNotCategorized(searchNoCategory);
    } else {
      setIsFiltering(false);
      setCategories(holdCategories);
      setNotCategorized(holdNoCategory);
    }
  };

  const renderNoCategoryFiles = (row) => {
    let isMainDisplayShowing = true;
    let formattedStartDate = "";
    if (row.startDate) {
      formattedStartDate = moment(row.startDate).format("MMM Do");
    }

    return (
      <Paper className={classes.paperHolder} onClick={() => handleSelectRow(row)}>
        <div>
          <span>
            <FontAwesomeIcon
              icon={/contacts/i.test(module) ? faUser : faFile}
              size="1x"
              className={clsx(classes.iconColor, classes.childIcon)}
            />
          </span>
          {
            React.Children.toArray(mainDisplayColumns.map((column) => {
              row[column] ? isMainDisplayShowing = true : isMainDisplayShowing = false;
              return (
                <span className={classes.paperTitle}>
                  {row[column]}&nbsp;
                </span>
              )}
            ))
          }
          {!isMainDisplayShowing && (
            row[altDisplayColumn] && !row[altDisplayColumn].includes("http") && (
              <span className={classes.paperText}>
                {row[altDisplayColumn]}
              </span>
            )
          )}
          {module === "continuing education" && (
            <span className={classes.paperText}>
              - {formattedStartDate}
            </span>
          )}
        </div >
      </Paper >
    )
  }

  const renderCategories = (row, rowIndex) => {
    return (
      <>
        {row.category && (
          <Paper
            className={classes.paperHolder}
            onClick={() => handleSelectCategory(row, rowIndex)}
          >
            <div>
              <span>
                <IconButton className={classes.parentIcon}>
                  <FolderIcon />
                </IconButton>
              </span>
              <span className={classes.paperTitle}>{row.category}</span>
            </div>
            <div>
              {row[altDisplayColumn] && (
                <span className={classes.paperText}>
                  {row[altDisplayColumn]}
                </span>
              )}
            </div>
          </Paper>
        )}
      </>
    );
  };

  const handleSelectRow = (row) => {
    if (hasModal) {
      if (row.formName === 'Respiratory Fit Test' && !hasRespMedClearance) {
        return setOpenRespAlert(true);
      } 
    
      switch (row.formName) {
        case 'Respiratory Fit Test':
          setSafetyFormSelected({
            ...safetyFormSelected,
            formName: row.formName,
            formID: '242'
          });
          break;
        case 'EVOC':
          setSafetyFormSelected({
            ...safetyFormSelected,
            formName: row.formName,
            formID: '189'
          });
          break;
        case 'Safe Stretcher Handling':
          setSafetyFormSelected({
            ...safetyFormSelected,
            formName: row.formName,
            formID: '997'
          });
          break;
        default:
          break;
      }
      return setOpenModal(true);
    }
    setIsViewingFile(true);
    if (isForm) {
      onRowSelected(row);
    } else {
      setSelectedRow(row);
    }
  };

  const handleSelectCategory = (row, rowIndex) => {
    let selectedData = [];
    for (let i = 0; i < filteredData.length; i++) {
      if (row.category === filteredData[i].categoryTitle) {
        selectedData.push(filteredData[i]);
      }
      if (row.category === "No Category" && !filteredData[i].categoryTitle) {
        selectedData.push(filteredData[i]);
      }
    }
    setSelectedCategory(selectedData);
    let temp = categories.slice();
    if (_.has(temp[rowIndex], "isViewing"))
      temp[rowIndex].isViewing = !temp[rowIndex].isViewing;
    if (!temp[rowIndex].isViewing) setSelectedRow();
    setLastSelectedIndex(rowIndex);
    if (
      lastSelectedIndex !== null &&
      lastSelectedIndex !== rowIndex &&
      temp[lastSelectedIndex]
    ) {
      temp[lastSelectedIndex].isViewing = false;
      setSelectedRow();
    }
    setCategories(temp);
  };

  const handleSmallScreenBackButton = () => {
    setSelectedRow();
    setIsViewingFile(false);
  };

  // const renderSelfServiceUI = () => (
  //   <div className={classes.selfServiceWrapper}>
  //     {/* {selectedRow.categoryTitle && <Typography variant="h4" gutterBottom>{selectedRow.categoryTitle}</Typography>} */}
  //     {selectedRow.linkTitle && <Typography variant="h5" gutterBottom>{selectedRow.linkTitle}</Typography>}
  //     {selectedRow.linkURL && <Link to={{ pathname: selectedRow.linkURL }} target="_blank" rel="noopener noreferer"><Typography variant="body1" gutterBottom>{selectedRow.linkURL}</Typography></Link>}
  //     {selectedRow.notes && <Typography variant="body2" gutterBottom>{selectedRow.notes}</Typography>}
  //     {/* {selectedRow.notes && <div dangerouslySetInnerHTML={{ __html: selectedRow.notes }} />} */}
  //   </div>
  // );

  return (
    <Grid container spacing={4}>
      {isLoading || originalData.length === 0 ? (
        <div className={classes.pagePaddingTop}>
          <EmptyStateHolder
            isLoading={isLoading}
            placeholderText={!isLoading ? emptyStateText : "Loading..."}
          />
        </div>
      ) : (
        <>
          <Grid
            item
            xs={12}
            md={4}
            className={
              isViewingFile ? classes.smallContainer : null
            }
          >
            {hasFilter && (
              <TextField
                label="Filter List"
                variant={"outlined"}
                fullWidth
                onChange={(e) => onFilterValueChange(e.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      <IconButton>
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            )}
            <br />
            <br />

            {categories.length > 1 && categories[0].category && isFiltering && (
              <Typography variant="body1" color="primary">
                Filtered Folders...
              </Typography>
            )}

            <Grid
              id="top-row"
              container
              className={classes[`${module}Categories`]}
            >
              {categories.map((row, rowIndex) => (
                <Grid item xs={12} key={rowIndex}>
                  {mainDisplayColumns.length > 0 &&
                    renderCategories(row, rowIndex)}
                  {row.isViewing &&
                    selectedCategory &&
                    selectedCategory.map((category) =>
                      renderNoCategoryFiles(category)
                    )}
                </Grid>
              ))}

              {notCategorized.length > 0 && isFiltering && (
                <Typography variant="body1" color="primary">
                  Filtered Files...
                </Typography>
              )}

              {(isFiltering || categories.length === 0) &&
                notCategorized.map((row, rowIndex) => (
                  <Grid item xs={12} key={rowIndex}>
                    {mainDisplayColumns.length > 0 &&
                      renderNoCategoryFiles(row)}
                  </Grid>
                ))}
            </Grid>

            {/* <Pagination
              count={pageCount}
              size="large"
              page={currentPage}
              variant="outlined"
              onChange={handleChange}
            /> */}
          </Grid>
          <Grid item xs={12} md={8}>
            {!selectedRow && filteredData.length > 0 && (
              <div className={classes.pagePaddingTop}>
                <EmptyStateHolder
                  displaySelectIcon={true}
                  placeholderText={/safety/i.test(module) ? "Select a form to complete" : "Select a record to view additional details"}
                />
              </div>
            )}

            {selectedRow &&
              !isPDFView &&
              (module === "contacts" ||
              module === "continuing education" ||
              module === "self service" ? (
                <ModuleList
                  data={selectedRow}
                  mainDisplayColumns={mainDisplayColumns}
                  altDisplayColumn={altDisplayColumn}
                />
              ) : (
                // /selfService/i.test(module) ? renderSelfServiceUI() :
                <>
                  {Object.keys(selectedRow).map((key, i) => (
                    <>
                      {![
                        "id",
                        "mobileSecurityID",
                        "modifiedBy",
                        "modifiedDate",
                      ].includes(key) &&
                        selectedRow[key] !== null &&
                        selectedRow[key].length > 0 && (
                          <p key={i}>
                            <span>
                              <strong>{titleCase(key)}:</strong>{" "}
                              {selectedRow[key]}
                            </span>
                          </p>
                        )}
                    </>
                  ))}
                </>
              ))}

            {isViewingFile && !isMd && (
              <Button variant="text" onClick={handleSmallScreenBackButton} className={classes.hidden}>
                <FontAwesomeIcon
                  icon={faChevronCircleLeft}
                  size="2x"
                  className={classes.iconColor}
                />
              </Button>
            )}

            {selectedRow && isPDFView && (
              <PDFViewerAndToolBar
                id={selectedRow.id}
                title={selectedRow.title}
                image={selectedRow.fileURL}
                isDownloadable={selectedRow.isDownloadable}
                pdfType={pdfType}
              />
            )}
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default DataListAndRowView;
